import { useEffect, useState } from "react"
import { getBarrioById, postBarrio, patchBarrio } from "../../services/BarriosServices"
import { BarriosFormContext } from "./BarriosContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const BarriosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const [provinciasData, setProvinciasData] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {

        if (id) getBarrioByIdData(id)
    }, [])

    const getBarrioByIdData = async (id) => {
        let res = await getBarrioById(id)
        
        if (res) setReport(res)
    }

    const postBarrioData = async (body) => {
        const res = await postBarrio(body)
        
        if (res) navigate("/barrios");
    }

    const patchBarrioData = async (id, body) => {
        const res = await patchBarrio(id, body)

        if (res) navigate("/barrios");
    }


    return <BarriosFormContext.Provider value={{
        report,
        provinciasData,
        postBarrioData,
        patchBarrioData,
    }} >
        {children}
    </BarriosFormContext.Provider>
}